import { createSlice } from "@reduxjs/toolkit";
import { getAdminHotelsListThunk } from "../thunks/hotelThunk";

const initialState = {
    hotels: null,
};

const hotelSlice = createSlice({
    name: "hotel",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAdminHotelsListThunk.fulfilled, (state, action) => {
            state.hotels = action?.payload?.data;
        })
    }
});

export default hotelSlice.reducer;
